import React from "react"

import { SEARCH_PAGE_SIZE } from "~config/constants"
import { TextSmallSecondary } from "~components/shared/todo-lib-react-components/text"

interface Props {
    readonly total: number
    readonly current: number
}

export default function PaginationSummary({ total, current }: Props) {
    const from = (current - 1) * SEARCH_PAGE_SIZE + 1
    const to = Math.min(current * SEARCH_PAGE_SIZE, total)

    return (
        <TextSmallSecondary>
            {`Showing ${from} - ${to} of ${total} results`}
        </TextSmallSecondary>
    )
}
